<template>
  <div>
    <div class="max-w-5xl mx-3 md:mx-auto">
      <div class="border-b border-gray-200 mb-5">
        <nav class="-mb-px flex">
          <a
            href="#"
            class="w-1/6 py-4 px-1 text-center font-medium text-sm leading-5 border-b-2 focus:outline-none"
            :class="
              !currentGrade
                ? 'border-indigo-500 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300'
            "
            @click.prevent="currentGrade = null"
          >
            전체
          </a>
          <a
            href="#"
            class="w-1/6 py-4 px-1 text-center font-medium text-sm leading-5 border-b-2 focus:outline-none"
            :class="
              currentGrade == 1
                ? 'border-indigo-500 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300'
            "
            @click.prevent="currentGrade = 1"
          >
            큰선생
          </a>
          <a
            href="#"
            class="w-1/6 py-4 px-1 text-center font-medium text-sm leading-5 border-b-2 focus:outline-none"
            :class="
              currentGrade == 5
                ? 'border-indigo-500 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300'
            "
            @click.prevent="currentGrade = 5"
          >
            선생
          </a>
          <a
            href="#"
            class="w-1/6 py-4 px-1 text-center font-medium text-sm leading-5 border-b-2 focus:outline-none truncate"
            :class="
              currentGrade == 11
                ? 'border-indigo-500 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300'
            "
            @click.prevent="currentGrade = 11"
          >
            1급지도자
          </a>
          <a
            href="#"
            class="w-1/6 py-4 px-1 text-center font-medium text-sm leading-5 border-b-2 focus:outline-none truncate"
            :class="
              currentGrade == 22
                ? 'border-indigo-500 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300'
            "
            @click.prevent="currentGrade = 22"
          >
            2급지도자
          </a>
          <a
            href="#"
            class="w-1/6 py-4 px-1 text-center font-medium text-sm leading-5 border-b-2 focus:outline-none truncate"
            :class="
              currentGrade == 33
                ? 'border-indigo-500 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300'
            "
            @click.prevent="currentGrade = 33"
          >
            3급지도자
          </a>
        </nav>
      </div>

      <div class="grid grid-cols-6 gap-4 row-gap-6">
        <div
          v-for="master in filteredMasters"
          :key="master.id"
          class="col-span-6 sm:col-span-3 md:col-span-2"
        >
          <a href="#" @click.prevent="viewMaster(master)">
            <div class="bg-white overflow-hidden shadow rounded">
              <div class="relative h-56 bg-gray-100">
                <img
                  :src="master.thumbnail"
                  class="absolute h-full w-full object-cover"
                />
              </div>
              <div class="px-2 py-4">
                <div class="text-center text-gray-800">
                  <div class="truncate">
                    {{ master.name }}
                    <span v-if="master.name_en" class="text-gray-700">
                      ({{ master.name_en }})
                    </span>
                  </div>
                  <div class="text-gray-500">
                    {{ master.grade_text }}
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div
        v-if="open"
        @click="open = false"
        class="fixed inset-0 h-screen overflow-y-auto px-2 py-3 sm:py-12"
        style="z-index: 1001"
      >
        <div class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div
          @click.stop
          class="bg-white rounded-lg pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-4xl sm:mx-auto sm:w-full sm:py-6"
          style="z-index: 1002"
        >
          <button
            type="button"
            aria-label="close"
            class="fixed top-0 right-0 text-xl text-gray-400 my-3 mx-3 border-0 bg-transparent"
            style="z-index: 1003"
            @click="open = false"
          >
            <svg
              class="fill-current w-6 h-6"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <title>닫기</title>
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <div class="text-base sm:text-sm">
            <div
              class="flex flex-col items-center px-4 md:px-6 py-5 border-b border-gray-200 sm:px-6"
            >
              <span class="mb-3">
                <img
                  :src="master.thumbnail"
                  class="inline-block rounded-md h-56 w-auto"
                />
              </span>
              <h3 class="text-lg font-semibold text-gray-900 my-0">
                {{ master.name }}
              </h3>
              <h4 class="text-base text-gray-500 my-1">
                {{ master.name_en }}
              </h4>
              <div class="mt-2">{{ master.gradeText }}</div>
              <div v-if="auth">
                <span class="inline-flex rounded-md shadow-sm">
                  <a
                    :href="`/masters/${master.id}/edit`"
                    class="inline-flex items-center py-1 px-3 border border-gray-300 text-sm leading-4 font-medium rounded-md gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition duration-150 ease-in-out"
                  >
                    수정
                  </a>
                </span>
              </div>
            </div>
            <div class="bg-gray-50 px-4 md:px-6 py-5 md:flex md:flex-wrap">
              <div class="md:w-1/4 font-medium text-gray-500">생년월일</div>
              <div class="md:w-3/4 text-gray-900">
                {{ master.dob }}
                {{ master.lunar ? '(음력)' : '' }}
              </div>
            </div>
            <div class="bg-white px-4 md:px-6 py-5 md:flex md:flex-wrap">
              <div class="md:w-1/4 font-medium text-gray-500">이메일주소</div>
              <div class="md:w-3/4 text-gray-900">
                <a :href="`mailto:${master.email}`">
                  {{ master.email }}
                </a>
              </div>
            </div>
            <div class="bg-gray-50 px-4 md:px-6 py-5 md:flex md:flex-wrap">
              <div class="md:w-1/4 font-medium text-gray-500">웹사이트/SNS</div>
              <div class="md:w-3/4 text-gray-900">
                <a v-if="master.website" :href="master.website" target="_blank">
                  {{ master.website }}
                </a>
              </div>
            </div>
            <div class="bg-white px-4 md:px-6 py-5 md:flex md:flex-wrap">
              <div class="md:w-1/4 font-medium text-gray-500">활동 지역</div>
              <div class="md:w-3/4 text-gray-900">
                {{ master.region }}
              </div>
            </div>
            <div class="bg-gray-50 px-4 md:px-6 py-5 md:flex md:flex-wrap">
              <div class="md:w-1/4 font-medium text-gray-500">지도 스승</div>
              <div class="md:w-3/4 text-gray-900">
                {{ master.teacher }}
              </div>
            </div>
            <div
              v-if="master.memo"
              class="bg-white px-4 md:px-6 py-5 md:flex md:flex-wrap"
            >
              <div class="md:w-1/4 font-medium text-gray-500">
                <br />자기소개 및 이력
              </div>
              <div class="md:w-3/4 text-gray-900 whitespace-pre-line">
                {{ master.memo }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    auth: Boolean,
  },

  data() {
    return {
      open: false,
      masters: [],
      master: null,
      currentGrade: null,
    }
  },

  created() {
    this.fetchData()
    // this.$nextTick(() => {
    //   page.initShuffle()
    // })
  },

  computed: {
    filteredMasters() {
      if (!this.currentGrade) {
        return this.masters
      }
      return this.masters.filter(x => x.grade === this.currentGrade)
    },
  },

  watch: {
    open(value) {
      if (value) {
        this.current = {}
        this.records = []
        this.fetchData()
        return document.querySelector('body').classList.add('overflow-hidden')
      }

      document.querySelector('body').classList.remove('overflow-hidden')
    },
  },

  methods: {
    async fetchData() {
      try {
        const response = await axios.get('/api/masters')

        this.masters = response.data.data
      } catch (error) {
        console.error(error)
      }
    },

    viewMaster(master) {
      this.master = master
      this.open = true
    },
  },
}
</script>
